import React, { useEffect } from "react";
import { render } from "react-dom";
import { observe } from "selector-observer";
import { Image } from "../../../../scripts/react/Image";
import { Karousel } from "../../../../scripts/react/Carousels";
import { DefaultClasses } from "../../../../scripts/react/Carousels/defaults";

export const FeaturedItem = (props) => {
    const { url, category, date, description, externalDescription, imageSrc, title, imageAlt } = props;

    return (
      <div className="featured-item-container">
          <a title={imageAlt} aria-label={imageAlt} href={url} className="preview-image">
              <Image src={imageSrc} alt={imageAlt} />
              <div className="category-container">
                  <span className="category">{category}</span>
              </div>
                <h4>{title}</h4>
                <p className="preview-desc">{description}</p>
                <p className="preview-desc">{externalDescription}</p>
          </a>
      </div>
  );
};



export const FeaturedItems = ({ disableAnimation, cards }) => {
    if (!cards?.length) return null;
    if (cards.length == 2) {
        return (
            <div className="row-two">
                {cards.map((card, index) => (
                    <FeaturedItem {...card} key={index} />
                ))}
            </div>
        )
    }
    return (
        <div className="row">
            {cards.map((card, index) => (
                <FeaturedItem {...card} key={index} />
            ))}
        </div>
  );
};

 document.addEventListener("readystatechange", () => {
     if (document.readyState === "interactive") {
         observe('[data-component="featureditems"]', {
             add(element) {
                 const { dataset } = element as HTMLElement;
                 const { propsId } = dataset;
                 const componentData = window.ucsdh[`featureditems_${propsId}`];
                 render(<FeaturedItems {...componentData} />, element);
             },
         });
     }
 });
